import "../style/azmoon-list/AL_PastExams.css";
import React from "react";
import exam_result_icon from "../../assets/azmoon-list/کارنامه.png";
import date_icon from "../../assets/azmoon-list/vuesax-linear-calendar.svg";
import hat_icon from "../../assets/azmoon-list/vuesax-linear-teacher.svg";
import type_icon from "../../assets/azmoon-list/vuesax-linear-profile-2user.svg";
import type_icon2 from "../../assets/azmoon-list/vuesax-linear-profile.svg";

// import as_bg_img from '../../assets/store/Group 148.png';

// import as_icon from '../../assets/store/discount-shape.png';
import { BsHeart } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import moment from "jalali-moment";
// import { useRef } from 'react';
// import ExamStore from '../dashboard/ExamStore';

// let common_data = [
//   {
//     id:1,
//     img:img1,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"450.200",
//     discounted_price:"405.000",
//     discount:"10%",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "discounted",
//     user_num:100,
//   },
//   {
//     id:2,
//     img:img3,
//     title:"آزمون زیست شناسی دهم",
//     // price:458.200,
//     price:"350.000",
//     discounted_price:"305.000",
//     discount:"10%",
//     date:"28 آبان 1400",
//     level:"کارشناسی",
//     type:"گروهی",
//     filter: "discounted",
//     user_num:100,
//   },
//   {
//     id:3,
//     img:img1,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"350.200",
//     discounted_price:"305.000",
//     discount:"10%",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "discounted",
//     user_num:100,
//   },
//   {
//     id:4,
//     img:img3,
//     title:"آزمون روان درمانی اگزیستانسیال",
//     // price:458.200,
//     price:"458.200",
//     discounted_price:"",
//     discount:"",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "none",
//     user_num:100,
//   },
//   {
//     id:5,
//     img:img2,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"458.200",
//     discounted_price:"",
//     discount:"",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "none",
//     user_num:100,
//   },
//   {
//     id:6,
//     img:img1,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"458.200",
//     discounted_price:"",
//     discount:"",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "none",
//     user_num:100,
//   },
//   {
//     id:7,
//     img:img1,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"350.000",
//     discounted_price:"",
//     discount:"",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "none",
//     user_num:100,
//   },
//   {
//     id:8,
//     img:img2,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"458.200",
//     discounted_price:"رایگان",
//     discount:"100%",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "free",
//     user_num:100,
//   }
// ]



const AL_PastExams = () => {
  const state = useSelector((state) => state.default);
  const [data] = useState(state.ExamData);
  // console.log(state.productFilter);

  useEffect(() => {
    if (state.openNav === "open") {
      let spcpItem = document.querySelectorAll(".spcp-item");
      // console.log(spcpItem.length);
      for (let i = 0; i < spcpItem.length; i++) {
        if (i % 4 !== 3) {
          spcpItem[i].style.marginLeft = "38px";
        }
        if (i % 4 === 3) {
          spcpItem[i].style.marginLeft = "0px";
        }
      }
    }
    if (state.openNav === "close") {
      let spcpItem = document.querySelectorAll(".spcp-item");
      // console.log(spcpItem.length);
      for (let i = 0; i < spcpItem.length; i++) {
        if (i % 4 !== 3) {
          spcpItem[i].style.marginLeft = "3.3%";
          // console.log(i+'xxxxxxxxxxxx');
        }
        if (i % 4 === 3) {
          spcpItem[i].style.marginLeft = "0px";
        }
      }
    }
  });
  // ------style-with-long-tilte----------------------------
  // let swlt = {
  //   width:"100%",
  //   textAlign:"center",
  //   fontSize:"14px"
  // }
  moment.locale("en");
  return (
    <div className="al-past-exams">
      <div className="al-past-exams-title">آزمون‌های گذشته</div>
      {data.map((item) => (
        <React.Fragment key={item.id}>
          {(item.filter === state.ExamFilter || state.ExamFilter === "all") && (
            <div
              style={item.id % 4 === 0 ? { marginLeft: 0 } : null}
              key={item.id}
              className="spcp-item"
            >
              <div className="spcp-item-img">
                <img src={item.img} alt="product-img" />
                <div className="alpe-item-img-cover"></div>
                <Link
                  to={`/dashboard/azmoon_list/exam-result/${item.id}`}
                  className="spcp-item-img-bag-icon"
                >
                  <img src={exam_result_icon} alt="bag-icon" />
                  <div className="spcp-item-img-bag-icon-hover-text">
                    مشاهده نتایج آزمون
                  </div>
                </Link>
                {/* <BsHeart className="spcp-item-img-heart-icon" /> */}
                <div className="as-item-userNum-container">
                  <div className="as-item-userNum">
                    <div className="as-item-userNum-item"></div>
                    <div className="as-item-userNum-item"></div>
                    <div className="as-item-userNum-item"></div>
                    <div className="as-item-userNum-item">+{item.count}</div>
                  </div>
                </div>
              </div>
              <div className="spcp-item-title-and-price">
                <div className="spcp_item_img_withe_space"></div>
                <div className="spcp-itap-title">{item.name}</div>
              </div>
              <div className="spcp-item-info">
                <div className="spcp-item-info-date-box">
                  <img src={date_icon} alt="date-icon" />
                  <div className="spcp-iidb-text">
                    {moment(item.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
                  </div>
                </div>
                <div className="spcp-item-info-level-box">
                  <img src={hat_icon} alt="hat-icon" />
                  <div className="spcp-iilb-text">{item.level}</div>
                </div>
                <div className="spcp-item-info-type-box">
                  {/* <img src={type_icon} alt="type-icon" />
                  <div className="spcp-iitb-text">{item.type}</div> */}
                  {item.type===2 && <img src={type_icon} alt="type-icon" />}
                  {item.type===1 && <img src={type_icon2} alt="type-icon" />}
                  {item.type===1 && <div className="spcp-iitb-text">
                    انفرادی
                  </div>}
                  {item.type===2 && <div className="spcp-iitb-text">
                    گروهی
                  </div>}
                </div>
              </div>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default AL_PastExams;
